<script setup lang="ts" generic="T">
interface Column { key: string; label: string; align?: 'left' | 'right' | 'center'; width?: string }
const props = defineProps<{ columns: Column[]; rows: T[]; rowKey: (row: T) => string | number; emptyMessage?: string }>()
const template = props.columns.map((c) => c.width ?? '1fr').join(' ')
</script>

<template>
  <div class="ck-table" role="table">
    <div class="ck-table-row ck-table-head" role="row" :style="{ gridTemplateColumns: template }">
      <span v-for="col in columns" :key="col.key" :style="{ textAlign: col.align ?? 'left' }">{{ col.label }}</span>
    </div>
    <p v-if="rows.length === 0" class="ck-table-empty">{{ emptyMessage ?? 'Nenhum item encontrado.' }}</p>
    <div v-for="row in rows" :key="rowKey(row)" class="ck-table-row" role="row" :style="{ gridTemplateColumns: template }">
      <slot :item="row" />
    </div>
    <div v-if="$slots.footer" class="ck-table-foot"><slot name="footer" /></div>
  </div>
</template>

<style scoped>
.ck-table { border: 1px solid var(--color-border); border-radius: var(--radius-lg); background: var(--color-surface); overflow: hidden; color: var(--color-text); }
.ck-table-row { display: grid; align-items: center; gap: var(--space-4); padding: 13px 20px; border-bottom: 1px solid var(--color-border); }
.ck-table-row:last-child { border-bottom: 0; }
.ck-table-head { font-size: 11px; font-weight: var(--fw-bold); letter-spacing: var(--ls-wider); text-transform: uppercase; color: var(--color-text-faint); padding-top: 12px; padding-bottom: 12px; }
.ck-table-empty { padding: 20px; color: var(--color-text-muted); font-size: 13px; }
.ck-table-foot { display: flex; justify-content: flex-end; gap: 24px; padding: 13px 20px; background: var(--color-surface-muted); }
</style>
